module.exports = __webpack_public_path__ + "img/soundsys@1x.33de381e.png";